import { render, staticRenderFns } from "./CardDataPopup.vue?vue&type=template&id=40aafca8&"
import script from "./CardDataPopup.vue?vue&type=script&lang=js&"
export * from "./CardDataPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports